import { Box, Grid, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { ArrayField, ChipField, Labeled, RecordContextProvider, SingleFieldList, TextField } from "react-admin";
import { settings } from "app";
import permissions from "app/permissions";
import { SectionTitle } from "features/SectionTitle";
import SecuredComponent from "server/security/SecuredComponent";
import EditAuthorNamesDialog from "./EditAuthorNamesDialog";
import EditIdentifierDialog from "./EditIdentifierDialog";
import { PROFILE_IDENTIFIERS } from "./usePublicationProfile";

// Each field has its own endpoint, so each one gets its own add/edit button next to its value.
const EditAction = ({ children }) => (
  <SecuredComponent permission={permissions.canUpdateScientificPublications}>
    <Box sx={{ mt: 0.5 }}>{children}</Box>
  </SecuredComponent>
);

// The profile is loaded by the page (usePublicationProfile) because the import button is gated by it too.
const PublicationProfileSection = ({ profile, onSaved }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SecuredComponent permission={permissions.canPreviewScientificPublications}>
      <SectionTitle
        paddingY={2}
        title="Научен профил"
        textAlign="center"
      />
      <Box sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}>
        {/* ChipField needs objects, so the plain name strings are exposed to the record as { id, name } items. */}
        <RecordContextProvider
          value={{ ...profile, authorNameItems: profile.authorNames.map(name => ({ id: name, name })) }}
        >
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
            >
              <Labeled label="Имена в публикации">
                <ArrayField source="authorNameItems">
                  <SingleFieldList
                    linkType={false}
                    empty={<Typography variant="body2">-</Typography>}
                  >
                    <ChipField
                      source="name"
                      size="small"
                    />
                  </SingleFieldList>
                </ArrayField>
              </Labeled>
              <EditAction>
                <EditAuthorNamesDialog
                  authorNames={profile.authorNames}
                  onSaved={onSaved}
                />
              </EditAction>
            </Grid>
            {PROFILE_IDENTIFIERS.map(({ source, label, url }) => (
              <Grid
                item
                xs={12}
                md={4}
                key={source}
              >
                <Labeled label={label}>
                  <TextField
                    source={source}
                    emptyText="-"
                  />
                </Labeled>
                <EditAction>
                  <EditIdentifierDialog
                    label={label}
                    source={source}
                    value={profile[source]}
                    url={url}
                    onSaved={onSaved}
                  />
                </EditAction>
              </Grid>
            ))}
          </Grid>
        </RecordContextProvider>
      </Box>
    </SecuredComponent>
  );
};

export default PublicationProfileSection;
